/** The base URL for the router. */
export const ROUTER_BASE = import.meta.env.VITE_ROUTER_BASE

/** The public routes. */
export const PUBLIC_ROUTE = {
  ACTIVATE_ACCOUNT: '/activate-account',
  FORGOT_PWD: '/forgot-pwd',
  RESET_PWD: '/reset-pwd',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
}

/** The private routes. */
export const PRIVATE_ROUTE = {
  DEVELOPMENT: '/development',
  FORM_TEST: '/form-test',
  FORM_TEST_ENTITIES: '/form-test-entities',
  HOME: '/',
  ROLES: '/roles',
  USUARIOS: '/users',
}

export const ROUTES_METHODS = [
  'DELETE',
  'GET',
  'HEAD',
  'OPTIONS',
  'PATCH',
  'POST',
  'PUT',
]

export const ROUTES_METHODS_OPTIONS = ROUTES_METHODS.map((item) => ({
  label: item,
  value: item,
}))
